export const GET_USER_INFO = 'user/GET_USER_INFO';
export const VALIDATE_USER = 'user/VALIDATE_USER';
